import React, { useState } from "react";
import { css } from "emotion";
import PubSub from "pubsub-js";
import { Input, Label } from "@maxmilhas/hangar-components-atomic/public";
import { intFormat } from "../../../../../js/shared/utils";
import { scrollToComponent } from "../../../shared/utils";
import { isMobile } from "../../../../../js/components/searchform/utils/common";
import ErrorMessage from "../../atoms/error-message";
import Select from "../../../../shared/Select/Select";
import { selectStyle } from "./style";

const QuickOfferFields = ({
	fidelities,
	setQuantMiles,
	setUserInteracted,
	userInteracted,
	fidelitySelected,
	quantMiles,
	onChangeFidelity: changeFidelity,
	minMilesAmount,
	maxMilesAmount
}) => {
	const [inputFocus, setInputFocus] = useState(false);

	const options = [];
	fidelities.map(airline =>
		airline.fidelities.map(fidelity => {
			options.push({
				...airline,
				...fidelity,
				value: fidelity.id,
				label: `${airline.airlineName} (${fidelity.name})`
			});
		})
	);

	const onChangeFidelity = option => {
		PubSub.publish("dataLayer", {
			event: "gaEvent",
			gaEventCategory: "Vender milhas",
			gaEventAction: "Venda rápida",
			gaEventLabel: "Programa de fidelidade",
			gaEventDetail: option.label
		});

		changeFidelity(option);
		if (quantMiles) {
			setUserInteracted(false);
			setQuantMiles("");
		}
	};

	const onChangeQuantMiles = (event, value) => {
		if (!userInteracted) setUserInteracted(true);
		let newValue = value !== undefined ? value : event.target.value;
		newValue = parseInt(("" + newValue).replace(/\D/g, ""));
		newValue = isNaN(newValue) ? "" : newValue;
		setQuantMiles(newValue);
	};

	let errorQuantMiles =
		userInteracted && (quantMiles < minMilesAmount || quantMiles > maxMilesAmount);
	let minQuantMiles = minMilesAmount || 3500;

	return (
		<>
			<div
				className={css`
					${selectStyle};
				`}
			>
				<Label>Programa de fidelidade</Label>
				<Select
					onChange={onChangeFidelity}
					value={fidelitySelected.id}
					options={options}
					icon
					selected={fidelitySelected}
					errorMessage={userInteracted && !fidelitySelected.id ? "" : undefined}
				/>
			</div>
			<Input
				label="Quantidade de milhas"
				placeholder={
					inputFocus || !fidelitySelected.id ? "" : `Mínimo de ${intFormat(minQuantMiles)}`
				}
				className="my-input-class quick-sale-qty-miles-lp"
				onChange={onChangeQuantMiles}
				value={intFormat(quantMiles)}
				maxLength={7}
				onClick={isMobile() ? () => scrollToComponent(".quick-sale-qty-miles-lp", 230) : undefined}
				onFocus={() => setInputFocus(true)}
				onBlur={() => setInputFocus(false)}
				hasError={errorQuantMiles}
				type="tel"
			/>
			{errorQuantMiles && (
				<ErrorMessage>
					{quantMiles > maxMilesAmount
						? `Máximo de ${intFormat(maxMilesAmount)} milhas`
						: `Mínimo de ${intFormat(minQuantMiles)} milhas`}
				</ErrorMessage>
			)}
		</>
	);
};

export default QuickOfferFields;
